import { z } from "zod";

// Skema untuk data utama
const ReportReservationDataV4Schema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/, "Invalid month format, expected YYYY-MM"),
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    total_earning: z.string().transform(val => parseFloat(val)),
});

// Skema untuk total per sumber (source)
const TotalSourceV4Schema = z.object({
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    total_earning: z.string().transform(val => parseFloat(val)),
});

// Skema untuk total per bulan
const TotalMonthV4Schema = z.object({
    month: z.string().regex(/^\d{4}-\d{2}$/, "Invalid month format, expected YYYY-MM"),
    total_earning: z.string().transform(val => parseFloat(val)),
});

// Skema utama untuk keseluruhan respons API V4
export const ReportReservationResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReportReservationDataV4Schema),
    total_source: z.array(TotalSourceV4Schema),
    total_month: z.array(TotalMonthV4Schema),
    total: z.string().transform(val => parseFloat(val)),
});

// Ekspor tipe TypeScript
export type ReportReservationResponseV4 = z.infer<typeof ReportReservationResponseV4Schema>;
export type TotalSourceV4 = z.infer<typeof TotalSourceV4Schema>;